// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3qvAs","notes":"Notes_notes__3m-TN","note":"Notes_note__1Y1Rs","markdown":"Notes_markdown__2cK9v"};